import React, { useState, useEffect, useRef } from 'react';
import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faXmark, faCircleCheck, faBolt, faPaperclip, faCircleXmark, faPlus, faEllipsis, faChevronLeft, faChevronRight, faLink } from '@fortawesome/free-solid-svg-icons';
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import JqxTreeGrid from 'jqwidgets-framework/jqwidgets-react-tsx/jqxtreegrid';
import 'jqwidgets-scripts/jqwidgets/jqxtreegrid';
import Trash from "../../../../assets/images/delete.svg";
import Export from "../../../../assets/images/export.svg";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";
import info from "../../../../assets/images/view.png";
import Rapdf from "../../../../assets/images/pdf.png";

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../../assets/images/google-docs.png';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Editor from 'react-simple-wysiwyg';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DownloadGrid from '../common/DownloadGrid';
import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import 'react-calendar/dist/Calendar.css';
import ApexCharts from 'react-apexcharts';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { TRUCKORDERLIST, TRUCKORDERDETAILS, OTCALENDER, CALENDER } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions';



// import jsPDF from 'jspdf';


const TruckActive = ({ updateGridData, forwardData }) => {
  const [activeTab, setActiveTab] = useState('Active');
  const [showSecondDiv, setShowSecondDiv] = useState(false);
  const toggleSecondDiv = () => {
    setShowSecondDiv(!showSecondDiv);
  };
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
  };
  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };
  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,

  };
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };
  const isMounted = useRef(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [gridSelect, setGridSelect] = useState([]);
  const [dateData, setDateData] = useState("");
  const gridRef = useRef(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: [],
    // Trash: []

  });
  const fetchData = async () => {
    try {

      const res = await withRFSToken.post(TRUCKORDERLIST, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          // 
          setGridData({ Active: innerData.export.active, Trash: innerData.export.trash || [] });
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // CALENDER
  const [borderDates, setBorderDates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lastDayOfMonth, setLastDayOfMonth] = useState(null);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    return `${year}-${month}-${day}`;
  };

  const getStartOfPreviousMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  };

  const getEndOfNextMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 2, 0); // 0th day gives last day of the next month
  };

  const getLastDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0); // 0th day of the next month gives last day of the current month
  };

  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const startOfPreviousMonth = getStartOfPreviousMonth(activeStartDate);
    const endOfNextMonth = getEndOfNextMonth(activeStartDate);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));

  };

  const handleMonthClick = (date) => {
    const lastDay = getLastDayOfMonth(date);
    setLastDayOfMonth(formatDate(lastDay));


    const startOfPreviousMonth = getStartOfPreviousMonth(date);
    const endOfNextMonth = getEndOfNextMonth(date);
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
  };

  const statusToColorMap = {
    R: '#D6D6D6',
    O: '#FF5522',
    B: '#FFB63F',
    RJ: '#20A749'
  };

  useEffect(() => {
    const now = new Date();
    const startOfPreviousMonth = getStartOfPreviousMonth(now);
    const endOfNextMonth = getEndOfNextMonth(now);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));

    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    // fetchDataGrid();
    setIsLoading(false);
    setGridData({ Active: {} });
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
    // fetchDataGridR();
    isMounted.current = true;
  }, []);
  const fetchCallanderData = async (sd, ed) => {
    try {
      // const dateP = dateData ? `date: ${dateData}` : ''
      const res = await withRFSToken.post(OTCALENDER, { tab_name: (activeTab == 'Active' ? 'OA' : (activeTab == 'Trash' ? 'OT' : '')), start_date: sd, end_date: ed })
        .then(function (res) {
          const innerData = res.data.response_data;
          // 
          const transformedDates = innerData.map(item => ({
            date: new Date(item.booking_date), // Convert booking_date to Date object
            colors: [statusToColorMap[item.planning_status]] // Get the corresponding color
          }));

          setBorderDates(transformedDates);

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const gridRefs = {
    Active: useRef(null),
    Trash: useRef(null),
  };
  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Trash: {} });
      }, 1);
    }
  };
  const [filterApplied, setFilterApplied] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      let urlAPI = "";
      if (dateData) {
        urlAPI = `${process.env.REACT_APP_RFS_URL}${TRUCKORDERLIST}?type=${tabType}&date=${dateData}`;
      } else {
        urlAPI = `${process.env.REACT_APP_RFS_URL}${TRUCKORDERLIST}?type=${tabType}`;
      }
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'OTN', type: 'string' },
          { name: 'BTN', type: 'string' },
          { name: 'Status', type: 'string' },
          { name: 'RStatus', type: 'string' },
          { name: 'departure_date', type: 'string' },
          { name: 'departure_time', type: 'string' },
          { name: 'board_point', type: 'string' },
          { name: 'off_point', type: 'string' },
          { name: 'truck_orders_id', type: 'string' },
          { name: 'pdf', type: 'string' },
          { name: 'arrival_date_time', type: 'string' },
          { name: 'departure_date_time', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}${TRUCKORDERLIST}?type=${tabType}&date=${dateData}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {

          source.totalrecords = data.TotalRows;
          const innerDataCal = data.chart_data;
          forwardData(innerDataCal)
          const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
          const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
          const condsData = statusData.map((value, index) => ({
            x: statusLabel[index],
            y: value,
            // fillColor: colors[index % colors.length]
          }));
          setStatusSeries([{
            name: "Bookingtruck",
            data: condsData
          }]);
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + info + '" class="row_info" /></div>';
          },

          width: '5%', filterable: false,
        },
        { text: 'Operational Truck No.', filtertype: 'textbox', datafield: 'OTN', width: '12%' },
        { text: 'Bookingtruck No.', filtertype: 'textbox', datafield: 'BTN', width: '12%' },
        // { text: 'Truck Load Plan', filtertype: 'textbox', datafield: 'truck_load_plan', width: '12%' },
        {
          text: 'Truck Load Plan', datafield: 'pdf', width: '8%',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: left;line-height: 44px; margin-left:10px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        // { text: 'Status', filtertype: 'textbox', datafield: 'Status', width: '17%', },
        {
          text: 'Status',
          filtertype: 'textbox',
          datafield: 'Status',
          width: '14%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            // Check the value of the 'Status' field
            if (rowdata.Status === 'Requested') {
              // Return HTML with class 'inactive' for 'i' status
              return '<div class="jqx-grid-cell-left-align bookingstatus scheduled">Requested</div>';
            } else if (rowdata.Status === 'Offer Received') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pprogress">Offer Received</div>';
            } else if (rowdata.Status === 'Booked') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pfinalized">Booked</div>';
            } else if (rowdata.Status === 'Rejected') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus rejected">Rejected</div>';
            } else {
              // Return default HTML
              return defaulthtml;
            }
          }
        },
        { text: 'Departure Date/Time', filtertype: 'textbox', datafield: 'departure_date_time', width: '12%' },
        { text: 'Arrival Date/Time', filtertype: 'textbox', datafield: 'arrival_date_time', width: '12%' },
        { text: 'Boardpoint', filtertype: 'textbox', datafield: 'board_point', width: '8%' },
        { text: 'Offpoint', filtertype: 'textbox', datafield: 'off_point', width: '8%' },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 50,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        rendered: function () {
          const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
          (checkUlds).forEach(uldNumber => {
            rows.forEach((element, index) => {
              if (element.uld_number == uldNumber) {
                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
              }
            });
          });
        }
      };
      window.$(gridRefs[activeTab]?.current).on('click', '.row_info', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab]?.current).jqxGrid('getrowdata', rowIndex);
        // setDeleteId(rowData.id);
        // setConfModal(true);

        getDeialsClick('shipment', rowData)
      });
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        // console.log('event', args)
        if (event.args.columnindex > 1) {

          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            // setGridSelect([]);
          }
          loadDetails(args.truck_orders_id);
          // setSelectedRowData(args);
        }
      });
      // window.$(gridRefs[activeTab]?.current).on('rowclick', async (event) => {
      //   const args = event.args.row.bounddata;

      //   loadDetails(args.truck_orders_id);
      // });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.OTN;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // 
          // if (!gridSelect.some(row => row.OTN === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.OTN === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.OTN;
          setGridSelect(prevSelection => prevSelection.filter(row => row.OTN !== unselectedRowId));
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });
    }
  }, [gridData]);
  const loadDetails = async (number, dateid) => {
    try {
      const res = await withRFSToken.post(TRUCKORDERDETAILS, { truck_orders_id: number })
        .then(function (res) {
          const innerData = res;
          if (res.data.response_code == 200) {
            setSelectedRowData(res.data.response_data);
            // setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            // }, 1);
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  }
  const truckOrderList = async () => {
    try {

      const res = await withRFSToken.post(TRUCKORDERLIST, { type: 'A' })
        .then(function (res) {
          const innerData = res.data.response_data;
          setGridData(innerData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleCloseClick = () => {
    setSelectedRowData(null);
    // setTimeout(() => {
    setIsLoading(false);
    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
    // }, 1);
  };
  // new start
  const [confirmModal, setConfirmModal] = useState(false);
  const confirmModalClose = () => {
    setConfirmModal(false);
  }

  const handleMoveTo = async (type) => {
    setConfirmModal(true);
    // const payload = {
    //   truck_orders_ids: gridSelect.map(item => item.truck_orders_id),
    //   status: type
    // };
    // try {
    //   const res = await withRFSToken.post('active-archive-truck-orders', payload)
    //     .then(function (res) {
    //       const innerData = res;
    //       if (res.data.response_code == 200) {
    //         setIsLoading(false);
    //         setGridSelect([]);
    //         window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
    //         window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');

    //       }
    //     });

    // } catch (error) {
    //   console.error('Error sending request:', error);
    // }
  };
  const handleMove = async (type) => {
    const payload = {
      truck_orders_ids: gridSelect.map(item => item.truck_orders_id),
      status: type
    };
    try {
      const res = await withRFSToken.post('active-archive-truck-orders', payload)
        .then(function (res) {
          const innerData = res;
          if (res.data.response_code == 200) {
            setIsLoading(false);
            setConfirmModal(false);
            setGridSelect([]);
            window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');

          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  };
  const handleDhandleMoveToeleteButtonClick = () => {
    deleteSelectedRows(gridSelect);
    // if (gridSelect){
    //   handleShowConfirmation(deleteSelectedRows);
    // }
  };
  const deleteSelectedRows = async (selectedIds) => {
    // Perform deletion logic here using the selected IDs

    const uniqueIds = Array.from(new Set(selectedIds));
    // Now you can send the selected IDs to your API or perform any other action
    if (selectedIds.length > 0) {
      // try {
      //   const response = await withRFSToken.post(BOOKINGTRUCKMOVE, { bookingtruck_nos: uniqueIds, action: 'D' });
      //   
      //   if (!response.ok) {
      //     throw new Error('Failed to add data');
      //   }
      //   // reloadGrid();
      // } catch (error) {
      //   console.error('Error fetching data:', error);
      // }
    }
    window.$(gridRefs[activeTab]?.current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab]?.current).jqxGrid('clearselection');
    // dispatch(fetchStationGridData());
    // reloadGrid();
  };

  const showDownloadModal = () => {
    setDownloadOpen(true);
  };
  const closeDownloadModal = () => {
    setDownloadOpen(false);
  };

  const handleDayClick = async (date, event) => {
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    setDateData(formattedDate);
    setIsLoading(true);
    if (activeTab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Trash: {} });
      }, 1);
    }
    // handleActiveStartDateChange(date);
  };
  // const borderDates = [
  //   { date: new Date(2024, 8, 15), colors: ['red'] },
  //   { date: new Date(2024, 8, 20), colors: ['orange'] },
  //   { date: new Date(2024, 8, 25), colors: ['yellow'] },
  // ];

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const dateEntry = borderDates.find(d => d.date.toDateString() === date.toDateString());
      const colors = dateEntry?.colors || [];

      return (
        <div className="multi-border" style={{ height: '100%' }}>
          {colors.map((color, index) => (
            <div
              key={index}
              className="border-stripe"
              style={{ borderBottom: `3px solid ${color}` }}

            />
          ))}
        </div>
      );
    }
    return null;
  };

  // ++++++++++++++ Status Overview

  const [statusOptions, setStatusOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // This will hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        distributed: true,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      formatter: (val) => {
        return val;
      },
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [
        ['Requested'],
        ['Offer', 'Received'],
        ['Booked'],
        ['Rejected'],
      ],
    },
    yaxis: {
      title: {
        text: ' '
      }
    },
    fill: {
      opacity: 1,
      colors: [
        "rgba(214, 214, 214, 1)",
        "rgba(255, 182, 63, 1)",
        'rgba(32, 167, 73, 1)',
        "rgba(255, 85, 34, 1)",
      ]
    },
    legend: {
      show: false
    },
    colors: ['#d6d6d6', '#ff5522', '#ffb63f', '#20a749'], // Different colors for each bar group
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " units";
        }
      }
    }
  });

  const [statusSeries, setStatusSeries] = useState([
    {
      name: 'Units Sold',
      data: [36, 20, 16, 8,]
    },
  ]);
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  const handleOrderTruck = () => {
    localStorage.removeItem('OT');
    const sendData = {
      truck_type: 'B',
      bookingTruck_type: 'E',
      existing_date: selectedRowData.date
    }
    localStorage.setItem('OT', JSON.stringify(sendData));
    window.location.href = '/OrderTruck'
  }

  const getDeialsClick = (e, values = null) => {
    localStorage.removeItem('TODetails');
    const alldata = values ? values : selectedRowData;
    const storageData = { ...alldata, tab: 'manage' };
    localStorage.setItem('TODetails', JSON.stringify(storageData));
    window.location.href = '/TruckOrderDetails'
  }

      const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

  return (
    <>
      {downloadOpen && <DownloadGrid download_area='to' download_sec={activeTab} onClose={closeDownloadModal} />}
      <div className='exp-btn'>
        <button onClick={() => handleMoveTo(activeTab === 'Active' ? 'R' : 'A')}><img src={activeTab === 'Active' ? Arcv : Activ} alt={activeTab} />  Move to {activeTab === 'Active' ? 'Archive' : 'Active'}</button>
        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
      </div>
      <div className="maindiv">
        <div className='trashdonload'> {/* rfs_grid */}
          <Tabs defaultActiveKey={activeTab} id="nested" className="booking_tab" onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''}>
            <Tab eventKey="Active" title={<span>Active</span>} className='position-relative'>
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
            </Tab>
            <Tab eventKey="Trash" title={<span>Archive</span>} className='position-relative'>
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Trash} className='bookinggrid' ></div>
              </>
              }
            </Tab>
          </Tabs>
        </div>
        {/* <div className='rfsRight mt-45'>
          {!selectedRowData && (
            <>
              <div className='calender_rfs mb-3'>
                <div>
                  <Calendar
                    tileClassName={({ date, view }) =>
                      view === 'month' && date.toDateString() === new Date().toDateString() ? 'selected-tile' : ''
                    }
                    tileContent={tileContent}
                    onClickDay={(date, event) => handleDayClick(date, event)}
                    // onClick={(event) => handleDayClick(date, event)}
                    // onClickMonth={() => handleMonthClick(activeStartDate)}

                    onActiveStartDateChange={({ activeStartDate, view }) => {
                      if (view === 'month') {
                        handleMonthClick(activeStartDate);
                      }
                    }}
                  />
                </div>
              </div>

              <div className='calender_rfs'>
                <div className="new_chart">
                  <h3>Status Overview</h3>
                </div>
                <ApexCharts
                  options={statusOptions}
                  series={statusSeries}
                  type="bar"
                  height={280}
                />
              </div>
            </>

          )}
          
        </div> */}
        {selectedRowData && (
          <div className='rfsRight mt-45'>
            <div className='SecondDiv rfs_width ord_truck'>
              <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
              <div className='girddtals_header'>
                <h3>
                  {selectedRowData.truck_no}
                  <span className='left_rqst'>
                    {
                      selectedRowData.Status == 'r' ? (
                        <label className="bookingstatus requested">Requested</label>
                      ) : selectedRowData.Status == 'o' ? (
                        <label className="bookingstatus offered">Offer Received</label>
                      ) : selectedRowData.Status == 'b' ? (
                        <label className="bookingstatus booked">Booked</label>
                      ) : ''
                    }
                  </span>
                </h3>
                <div className='d-flex actbtn justify-content-between'>
                  <div className='d-flex actbtn'>

                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                    {/* <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <FontAwesomeIcon icon={faBolt} /> Action
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">Edit Bookingtruck</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">Manage Shipments</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={handleOrderTruck}>Order Truck</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}

                  </div>
                  <div className='viwall'>
                    <Link to='#' onClick={() => getDeialsClick('shipment')}>View Details</Link>
                  </div>
                </div>
              </div>
              {selectedRowData.coload?.map((co, index) => (
                <div key={`${index}_col`} className='order_duplicate'>
                  <p>Bookingtruck No - <span>{co.bookingtruck_no} </span></p>
                  <div className='d-flex justify-content-between rabord'>
                    <div className='firstbrd'>
                      <p>Boardpoint</p>
                      <span>{co.board_point}</span>
                    </div>
                    <div className='middlebrd'>
                      {/* <p>{co.departure_date}</p> */}
                      <span style={{ fontSize: '14px' }}><b>DEP : </b>{selectedRowData?.departure_date}  {selectedRowData?.departure_time}</span>
                      <p><img src={Cargotruck} /></p>
                      <span style={{ fontSize: '14px' }}><b>ARR : </b>{selectedRowData?.arrival_date}  {selectedRowData?.arrival_time}</span>
                    </div>
                    <div className='lastbrd'>
                      <p>Offpoint</p>
                      <span>{co.off_point}</span>
                    </div>
                  </div>
                </div>
              ))}

              <div>
                {/* <h3>Operational Trucks</h3> */}
                <div className='opttrauck mb-3'>
                  <Accordion defaultActiveKey="0" flush>
                    <Accordion.Item>
                      <Accordion.Header>Truck Information</Accordion.Header>
                      <Accordion.Body>
                        <ul className='truck_info'>
                          <li><span>Type :</span> <span>Booking Truck</span></li>
                          {/* <li><span>Date and Time  :</span> <span>{selectedRowData.departure_date} {selectedRowData.departure_time}</span></li> */}
                          <li><span>Departure Date/ Time  :</span> <span>{selectedRowData.departure_date} {selectedRowData.departure_time}</span></li>
                           <li><span>Arival Date / Time  :</span> <span>{selectedRowData.arrival_date} {selectedRowData.arrival_time}</span></li>
                          {/* <li><span>Type of work :</span> <span>{selectedRowData.booking_type == 'E' ? 'Export' : 'Import'}</span></li> */}
                          <li><span>Truck Load  :</span> <span> {selectedRowData.service_type == 'F' ? 'FLT' : selectedRowData.service_type_value - 'LTL'}</span></li>
                          <li><span>Temperature  :</span> <span>{selectedRowData.temperature == '18-21' ? '18-21' : 'NO'}</span></li>
                          <li><span>Number of Drivers  :</span> <span>{selectedRowData.driver_number}</span></li>
                          <li><span>Truck Material  :</span> <span>{selectedRowData.truck_material === 'HC' ? 'Hard Cover' : selectedRowData.truck_material === 'CS' ? 'Curtain Slider' : selectedRowData.truck_material === 'FT' ? 'Flatbed Trailer' : 'Unknown'}</span></li>
                          <li><span>ADR Required  :</span> <span>{selectedRowData.adr_required == '1' ? 'YES' : 'NO'}</span></li>
                          <li><span>Boardpoint Address  :</span> <span>{selectedRowData.board_point_station_address}</span></li>
                          <li><span>Offpoint Address  :</span> <span>{selectedRowData.off_point_station_address}</span></li>
                          <li><span>Min Truck Height(cm)  :</span> <span>{selectedRowData.truck_height} cm</span></li>
                          <li><span>Rollerbed :</span> <span>{selectedRowData.rollerbed === 'Y' ? 'YES' : 'NO'}</span></li>
                          <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    {/* <Accordion.Item eventKey="1">
                      <Accordion.Header>Trucks No : #12345679</Accordion.Header>
                      <Accordion.Body>
                      <ul className='truck_info'> 
                          <li><span>Truck Load :</span> <span>FLT</span></li>
                          <li><span>Temperature :</span> <span>17°C - 19°C</span></li>
                          <li><span>Number off Drivers :</span> <span>1</span></li>
                          <li><span>ADR Required :</span> <span>YES</span></li>
                          <li><span>Remarks :</span> <span>Remarks</span></li>
                        </ul> 
                      </Accordion.Body>
                    </Accordion.Item> */}
                  </Accordion>
                </div>
              </div>

              <div className='mb-3'>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                  <h3 className='mb-0'>Truck Request</h3>
                  <h4 className='manag_offer' style={{ cursor: 'pointer' }} onClick={() => getDeialsClick('manage')}> Manage Offers <span>{selectedRowData.truck_order_requests?.length} </span></h4>
                </div>
                {selectedRowData.truck_order_requests?.map((req, index) => (
                  <div
                    className={
                      `d-flex justify-content-between align-items-center
                      ${req.request_status == 'Requested' ? 'order_rqst'
                        : (req.request_status == 'Rejected' || req.request_status == 'No Availability') ? 'order_reject'
                          : req.request_status == 'Booked' ? 'order_book' : 'offerbg'}`
                    }
                  >
                    <div><span>Trucker Name</span><h4>{req.trucker_name}</h4></div>
                    <div className='received'><span>{req.request_status}</span></div>
                    <div className='offer_price'>{req?.currency_type} {req?.response_amount}</div>
                  </div>
                ))}
                {/* <div className="d-flex justify-content-between align-items-center offerbg">
                  <div><span>Trucker Name</span><h4>Trucker 1</h4></div>
                  <div className='received'><span>Offer Received</span></div>
                  <div></div>
                </div> */}
              </div>

              <ImageUpload
                ref={imageUploadRef}
                attachable_type={"truck_order"}
                attachable_id={selectedRowData.truck_orders_id}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.truck_orders_id)}
              />
              <ActivityComments
                commentable_type={"truck_order"}
                commentable_id={selectedRowData.truck_orders_id}
                allactivities={selectedRowData.activities}
                onReloadDetails={loadDetails}
              />


              {/* <div className='mb-3'>
                <div className='d-flex justify-content-between align-items-center'>
                  <h3 className='mb-0'>Attachments</h3>
                  <div className='d-flex rightdrop'>
                    <Dropdown>
                      <Dropdown.Toggle variant="link" id="dropdown-basic">
                        <FontAwesomeIcon icon={faEllipsis} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">Open gallery view</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">Download all</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                    >
                      <button className='raplas' onClick={handleBrowseFiles}><FontAwesomeIcon icon={faPlus} /></button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        multiple
                      />


                    </div>
                  </div>
                </div>

                <div className='raslider'>
                  <div className="slider-container">
                    {
                      files.length > 3 ?
                        <Slider {...settings}>
                          {files.map((file, index) => (
                            <div key={index} className='slideimg'>
                              {file.type.startsWith('image/') ? (
                                <>
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt="Preview"
                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                    onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  />
                                  <span className='rafilename'>{file.name}</span>
                                </>
                              ) : (
                                <span className='d-flex rafilename'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                              )}
                              <button className='slide_dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faXmark} color='#656565' /></button>
                            </div>
                          ))}
                        </Slider>
                        :
                        <>
                          <div className='nonslide'>
                            {files.map((file, index) => (
                              <div key={index} className='slideimg'>
                                {file.type.startsWith('image/') ? (
                                  <>
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="Preview"
                                      style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                      onClick={() => handleFileClick(URL.createObjectURL(file))}
                                    />
                                    <span className='rafilename'>{file.name}</span>
                                  </>
                                ) : (
                                  <span className='d-flex rafilename'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                )}
                                <button className='slide_dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faXmark} color='#656565' /></button>
                              </div>
                            ))}
                          </div>
                        </>
                    }


                  </div>

                  <Modal show={show} onHide={handleClose} centered className='imgmodal'>
                    <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                    <Modal.Body >
                      {
                      <img src={selectedFile} className="img-fluid" alt="Selected" />
                    </Modal.Body>
                  </Modal>

                </div>

              </div>
              <div>
                <h3>Activity</h3>

                <div className='activity'>
                  <span>Show :</span>
                  <Button variant="link">All</Button>
                  <Button variant="link active">Comments</Button>
                  <Button variant="link">History</Button>
                </div>
                <div className='activity'>
                  <span>Truck :</span>
                  <Button variant="link">All</Button>
                  <Button variant="link">#123</Button>
                  <Button variant="link">#124</Button>
                  <Button variant="link">#125</Button>
                  <Button variant="link">#126</Button>
                </div>
              </div>
              <div className='mt-4'>
                <div>
                  <div className='d-flex comntbox'>
                    <div>
                      <span className='user_com'>RS</span>
                    </div>
                    <div className='edithtml'>
                      <CKEditor
                        editor={ClassicEditor}
                        data="<p> Hello </p>"
                        onReady={editor => {
                          // You can store the "editor" and use when it is needed.
                          
                        }}
                        onChange={(event) => {
                          
                        }}
                        onBlur={(event, editor) => {
                          
                        }}
                        onFocus={(event, editor) => {
                          
                        }}
                      />
                    </div>
                  </div>
                  <div className='commnt_save'>
                    <Button variant="primary rasave">Save</Button>
                    <Button variant="link racancel">Cancel</Button>
                  </div>
                </div>
                <div className='d-flex racomment'>
                  <div className='coment_img'><img src={Cuser} /></div>
                  <div>
                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> </div>
                    <p>I have no reply, so i will take this ticket to next week</p>
                  </div>
                </div>
                <div className='d-flex racomment'>
                  <div className='coment_img'><img src={Cuser} /></div>
                  <div>
                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                    <p>I have no reply, so i will take this ticket to next week</p>
                  </div>
                </div>
                <div className='d-flex racomment'>
                  <div className='coment_img'><img src={Cuser} /></div>
                  <div>
                    <div className='d-flex'> <h3>Patricia Modispacher </h3> <span>3 days ago</span> <Button variant="link"><FontAwesomeIcon icon={faLink} /></Button> </div>
                    <p>I have no reply, so i will take this ticket to next week</p>
                  </div>
                </div>
              </div> */}



            </div>
          </div>
        )}
      </div>
      <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>{activeTab !== 'Active' ? 'Active Truck Orders' : 'Archive Truck Orders'}</h2>
          <p>
            {activeTab !== 'Active' ? 'Are you sure you want to active the selected truck orders.' : 'Are you sure you want to archive the selected truck orders.'}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => handleMove(activeTab === 'Active' ? 'R' : 'A')}>
            {activeTab === 'Active' ? 'Archive' : 'Active'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default TruckActive;
// export {JGrid as default, exportToPDF}